/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * SERVICE_DEFINITION_V2.SERVICE_ID values for Private Banking products
 * @export
 */
export const PrivateBankingServiceDefinitionId = {
    Ai: 'AI',
    Ebanking: 'EBANKING',
    Edocument: 'EDOCUMENT',
    Otc: 'OTC',
    Mf: 'MF',
    RegisteredShare: 'REGISTERED_SHARE',
    DeedOfPledge: 'DEED_OF_PLEDGE',
    DeedOfPledgeDebtor: 'DEED_OF_PLEDGE_DEBTOR',
    DeedOfPledgeGuarantor: 'DEED_OF_PLEDGE_GUARANTOR',
    SecuritiesLending: 'SECURITIES_LENDING',
    SecuritiesBorrowing: 'SECURITIES_BORROWING',
    DebitMaestrocard: 'DEBIT_MAESTROCARD',
    UsIpo: 'US_IPO',
    TaxExempt: 'TAX_EXEMPT',
    InformedInvestor: 'INFORMED_INVESTOR',
    DeclarationOtc: 'DECLARATION_OTC',
    CreditAgreement: 'CREDIT_AGREEMENT',
    ServiceModel: 'SERVICE_MODEL',
    SafeDepositBox: 'SAFE_DEPOSIT_BOX',
    SafeClearing: 'SAFE_CLEARING',
    WealthPlanningServices: 'WEALTH_PLANNING_SERVICES',
    HoldMail: 'HOLD_MAIL',
    PeriodicMailDispatch: 'PERIODIC_MAIL_DISPATCH',
    ActiveReferralWp: 'ACTIVE_REFERRAL_WP',
    ActiveReferralRm: 'ACTIVE_REFERRAL_RM',
    ReferralBjbgermany: 'REFERRAL_BJBGERMANY',
    Mt: 'MT'
} as const;
export type PrivateBankingServiceDefinitionId = typeof PrivateBankingServiceDefinitionId[keyof typeof PrivateBankingServiceDefinitionId];


export function instanceOfPrivateBankingServiceDefinitionId(value: any): boolean {
    for (const key in PrivateBankingServiceDefinitionId) {
        if (Object.prototype.hasOwnProperty.call(PrivateBankingServiceDefinitionId, key)) {
            if (PrivateBankingServiceDefinitionId[key as keyof typeof PrivateBankingServiceDefinitionId] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PrivateBankingServiceDefinitionIdFromJSON(json: any): PrivateBankingServiceDefinitionId {
    return PrivateBankingServiceDefinitionIdFromJSONTyped(json, false);
}

export function PrivateBankingServiceDefinitionIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateBankingServiceDefinitionId {
    return json as PrivateBankingServiceDefinitionId;
}

export function PrivateBankingServiceDefinitionIdToJSON(value?: PrivateBankingServiceDefinitionId | null): any {
    return value as any;
}

export function PrivateBankingServiceDefinitionIdToJSONTyped(value: any, ignoreDiscriminator: boolean): PrivateBankingServiceDefinitionId {
    return value as PrivateBankingServiceDefinitionId;
}

